<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60">
    <path fill-rule="evenodd" :fill="colorSet" d="M29.999.1c16.569 0 30 13.33 30 29.899 0 16.567-13.431 29.999-30 29.999C13.431 59.998 0 46.566 0 29.999 0 13.43 13.431.1 29.999.1z"/>
    <path v-if="state === '안정'" fill-rule="evenodd" fill="#FFF" d="M43.629 37.249c-.16.272-.752 1.35-.976 2.331-2.664 3.651-7.336 6.419-12.654 6.419-5.337 0-10.023-2.788-12.682-6.879.043-.561-.787-1.599-.947-1.871a1.5 1.5 0 0 1 .549-2.049c.717-.415 1.635.11 2.049.549.16.251.495 1.003.663 1.681 2.081 3.175 5.945 5.568 10.368 5.568 4.408 0 8.26-2.375 10.347-5.188.35-1.251.525-1.81.964-2.061.135-.439 1.052-.964 2.49-.549-.003.414.63 1.331-.171 2.049zm-4.63-10.25a3.001 3.001 0 0 1 0-6 3 3 0 1 1 0 6zm-18 0a3.001 3.001 0 0 1 0-6 3 3 0 1 1 0 6z"/>
    <path v-else-if="state === '양호'" fill-rule="evenodd" fill="#FFF" d="M38.999 26.998a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm-1.216 13.817a1.5 1.5 0 0 1 2.034.602c.396.728.126 2.143-.602 2.034-.278.149-1.346.759-1.777 1.033-2.004.976-4.207 1.496-6.338 1.916h-2.102c-2.23-.42-4.433-.94-6.437-1.916-.431-.274-.941-.884-1.777-1.033-.224.109-.998-1.306-.602-2.034a1.5 1.5 0 0 1 2.034-.602c.267.131.709.516 1.28.778 1.664.809 3.436 1.377 6.104 1.807h1.393c2.677-.43 3.99-.998 5.51-1.807 1.237-.262 1.013-.647 1.28-.778zM20.999 26.998a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
    <path v-else-if="state === '위험'" fill-rule="evenodd" fill="#FFF" d="M43.8 43.798c-1.438.414-2.355.168-2.49-.549-.439-.252-.614-.811-.964-1.333a11.997 11.997 0 0 0-10.347-5.918 11.995 11.995 0 0 0-10.368 5.956c-.168.291-.503 1.043-.663 1.295a1.5 1.5 0 0 1-2.598-1.501c.16-.272.99-1.31.947-1.763 2.659-4.198 7.345-6.987 12.682-6.987 5.318 0 9.99 2.768 12.654 6.941.224.459.816 1.537.976 1.809.801.718.168 1.635.171 2.05zm-4.801-16.799a3.001 3.001 0 0 1 0-6.001 3 3 0 0 1 0 6.001zm-18 0a3.001 3.001 0 0 1 0-6.001 3 3 0 0 1 0 6.001z"/>
    <path v-else-if="state === '주의'" fill-rule="evenodd" fill="#FFF" d="M38.999 29.999a6 6 0 1 1 .002-12.002A6 6 0 0 1 38.999 30zm0-9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-2 20.999c0 4.971-3.134 9.001-7 9.001s-7-4.03-7-9.001c0-4.718 3.134-9 7-9s7 4.282 7 9zm-16-11.999a6 6 0 1 1 .002-12.002A6 6 0 0 1 20.999 30zm0-9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"/>
  </svg>
</template>
<script>
export default {
  props: {
    state: String,
  },
  computed: {
    colorSet () {
      switch (this.state) {
        case '안정':
          return '#5CB0FF'
        case '양호':
          return '#7CCDC0'
        case '위험':
          return '#FF9595'
        case '주의':
          return '#F9D378'
      }
      return '#fefefe'
    }
  }
}
</script>
